const styles = {
  root: {
    display: 'flex',
    pt: { xs: 4, md: 9 },
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'primary.contrastText',
    width: '100%',
  },
  title: {
    fontWeight: 600,
    pr: 2,
    pl: 2,
    mb: 2,
    '&.MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },
  subtitle: {
    maxWidth: '630px',
    color: 'common.black',
    pr: 2,
    pl: 2,
    mb: 2,
  },
  imageDesk: {
    width: '400px',
    margin: '0 auto',
    mt: 15,
    zIndex: 0,
    position: 'absolute',
  },

  image: {
    margin: '0 auto',
    mt: 35,
    zIndex: 0,
    position: 'absolute',
  },
  cts: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

}

export default styles
